// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"PerMonthPointsList--next-sr-only--3EcWWNq"};